import { Component, OnInit } from '@angular/core';
import {YoutubeService} from "../../services/youtubeService/youtube.service";

declare var YT;

@Component({
  selector: 'app-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss']
})

export class VideoModalComponent implements OnInit {

  public Yiit = Yiit;
  public player;

  constructor() { }

  ngOnInit() {

    // this.player = this.yt.player;
  }


}
